module.exports = __webpack_public_path__ + "static/team_siddharth-a44a680c467deeb20a30ffc125241e23.jpg";